module.exports = __webpack_public_path__ + "img/close-popup-2.3fe16da6.svg";